<template>
<div class="chapter">
<div class="inner_page">
<p class="noindents1"><a id="ch00_fm06_pre1"></a><a id="page_xi"></a> <em>Author’s note.</em> This book is wholly fiction. Any resemblance to the present or past is gratuitous and similarity to any actual event or character is accidental and not intended.<a id="page_xii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06_pre1.vue?20e9ea80